import React, { createContext, useEffect, useState } from "react";
import GlobalHeader from "../../components/header";
import Footer from "../../components/footer";
import {
  Backdrop,
  CircularProgress,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import useSnack from "../../hooks/useSnack";
import useApi from "../../hooks/useApi";
import SnackAlert from "../../components/SnackAlert";
import CardElement from "../../components/CardElement";
import ContainerCardsOwn from "../../components/ContainerCardsOwn";
import ActionsNav from "../../components/ActionsNav";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import FilterOwnProperty from "../../components/Drawer/FilterOwnProperty";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";

export const ManagePropertyContext = createContext();

function MyProperty() {
  // DATA
  const [mainData, setMainData] = useState(false);
  const [filteredData, setFilteredData] = useState(false);
  const [paginatedData, setPaginatedData] = useState(false);
  const [locationList, setLocationList] = useState([]);

  // STATES
  const [page, setPage] = useState(1);
  const [allLoaded, setAllLoaded] = useState(false);
  const [backdropLoading, setBackdropLoading] = useState(false);
  const [expanded, setExpanded] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filtersSettings, setFiltersSettings] = useState({
    price: {
      min: "",
      max: "",
    },
    rooms: {
      min: "",
      max: "",
    },
    type: "all",
    location: "",
  });
  const ITEMS_PER_PAGE = 8;

  // UTILS
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const openMenuOrderBy = Boolean(anchorEl);
  const [openDrawer, setOpenDrawer] = useState(false);

  const handlerResetFilters = () => {
    setFiltersSettings({
      price: {
        min: "",
        max: "",
      },
      rooms: {
        min: "",
        max: "",
      },
      type: "all",
      location: "",
    });
    setFilteredData(mainData);
  };

  const handleClickOpenOrderBy = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeOrderBy = (value) => {
    let sortedData = [...mainData];
    if (value === "relevancia") {
      sortedData = mainData;
    } else if (value === "menorMayor") {
      sortedData = sortedData.sort(
        (a, b) => parseInt(a.price) - parseInt(b.price)
      );
    } else if (value === "mayorMenor") {
      sortedData = sortedData.sort(
        (a, b) => parseInt(b.price) - parseInt(a.price)
      );
    }
    setFilteredData(sortedData);
    setAnchorEl(null);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };

  const handleCloseMenuOrderBy = () => {
    setAnchorEl(null);
  };

  const GetOwnProperty = () => {
    setBackdropLoading(true);
    loadApi("state/states_profile", true, "get")
      .then((response) => {
        setMainData(response.data);
        setFilteredData(response.data);
        let locationsTemp = response.data.map((x) => x.location);
        locationsTemp = locationsTemp.filter(
          (n, index) => locationsTemp.indexOf(n) === index
        );
        setLocationList(locationsTemp);
        setPaginatedData(
          response.data.slice(
            (page - 1) * ITEMS_PER_PAGE,
            page * ITEMS_PER_PAGE
          )
        );
        setAllLoaded(true);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setBackdropLoading(false);
      });
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handlerSearchField = ({ target }) => {
    if (target.value.length === 0) {
      setPaginatedData(mainData);
    }

    const tempData = mainData.filter((x) =>
      x.name.toLowerCase().includes(target.value.toLowerCase())
    );
    setFilteredData(tempData);
  };
  const handlerFilterSet = () => {
    const mockUpData = {
      price: {
        min: "",
        max: "",
      },
      rooms: {
        min: "",
        max: "",
      },
      type: "all",
      location: "",
    };

    let filteredData = mainData;

    // FILTAR PRECIOS
    if (
      JSON.stringify(mockUpData.price) !== JSON.stringify(filtersSettings.price)
    ) {
      filteredData = filteredData.filter(
        (x) =>
          parseInt(x.price) >= filtersSettings.price.min &&
          parseInt(x.price) <= filtersSettings.price.max
      );
    }

    // FILTRAR HABITACIONES
    if (
      JSON.stringify(mockUpData.rooms) !== JSON.stringify(filtersSettings.rooms)
    ) {
      filteredData = filteredData.filter(
        (x) =>
          parseInt(x.bedrooms) >= filtersSettings.rooms.min &&
          parseInt(x.bedrooms) <= filtersSettings.rooms.max
      );
    }

    // FILTRAR TIPO
    if (filtersSettings.type !== "all") {
      filteredData = filteredData.filter(
        (x) => x.type === filtersSettings.type
      );
    }

    if (filtersSettings.location !== "") {
      filteredData = filteredData.filter(
        (x) => x.location === filtersSettings.location
      );
    }

    setOpenDrawer(false);
    setFilteredData(filteredData);
  };
  const handlerChangeExpanded = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(() => {
    if (!filteredData) {
      return;
    }
    let tempData = filteredData;
    tempData = tempData.slice(
      (page - 1) * ITEMS_PER_PAGE,
      page * ITEMS_PER_PAGE
    );

    setPaginatedData(tempData);
  }, [page]);

  useEffect(() => {
    if (!filteredData) {
      return;
    }
    let tempData = filteredData;
    tempData = tempData.slice(
      (page - 1) * ITEMS_PER_PAGE,
      page * ITEMS_PER_PAGE
    );
    setPaginatedData(tempData);
  }, [filteredData]);

  useEffect(() => {
    GetOwnProperty();
  }, []);

  return (
    <ManagePropertyContext.Provider
      value={{
        openDrawer,
        toggleDrawer,
        expanded,
        handlerChangeExpanded,
        filtersSettings,
        setFiltersSettings,
        handlerFilterSet,
        handlerResetFilters,
        locationList,
      }}
    >
      <GlobalHeader />
      <Stack
        sx={{
          minHeight: "calc(100vh - 120px)",
          width: { xs: "100vw", sm: "95vw", md: "90vw", lg: "75vw" },
          marginInline: "auto",
          pt: 5,
          backgroundColor: "white",
        }}
      >
        <Stack px={{ xs: 2, md: 4 }}>
          <ActionsNav
            title="Mis Inmuebles"
            icon={<MapsHomeWorkIcon fontSize="large" />}
            anchorEl={anchorEl}
            filteredData={filteredData}
            handleChangeOrderBy={handleChangeOrderBy}
            handleClickOpenOrderBy={handleClickOpenOrderBy}
            handleCloseMenuOrderBy={handleCloseMenuOrderBy}
            handlerSearchField={handlerSearchField}
            mainData={mainData}
            openMenuOrderBy={openMenuOrderBy}
            toggleDrawer={toggleDrawer}
            textOrder={{
              first: "Precio: menor a mayor",
              second: "Precio: mayor a menor",
            }}
          />

          {allLoaded && filteredData.length === 0 ? (
            <Stack pt={3}>
              <Typography color="GrayText" textAlign="center">
                No se encontraron inmuebles
              </Typography>
            </Stack>
          ) : (
            ""
          )}
          {allLoaded && (
            <Stack pt={3} pb={6}>
              <ContainerCardsOwn
                types="property"
                columns={3}
                data={paginatedData}
                childSizes={{ xs: 3, sm: 1.5, md: 1, lg: 1 }}
                editButton={false}
                detailsButton={false}
                deleteButton={false}
              />
              {allLoaded && filteredData.length !== 0 ? (
                <Pagination
                  count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
                  sx={{ marginInline: "auto", mt: 4 }}
                  page={page}
                  onChange={handlePageChange}
                />
              ) : (
                ""
              )}
            </Stack>
          )}
        </Stack>
      </Stack>
      <Footer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <FilterOwnProperty />
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </ManagePropertyContext.Provider>
  );
}

export default MyProperty;
